import Dexie, { type Table } from "dexie";
import type { PickscapeProject } from "../types";
import { DEFAULT_SETTINGS } from "../types";

interface StoredProjectRow {
  key: "active";
  project: PickscapeProject;
}

class PickscapeDatabase extends Dexie {
  projects!: Table<StoredProjectRow, "active">;

  constructor() {
    super("pickscape");
    this.version(1).stores({
      projects: "key",
    });
  }
}

const database = new PickscapeDatabase();

export async function saveRememberedProject(project: PickscapeProject): Promise<void> {
  await database.projects.put({ key: "active", project });
}

export async function loadRememberedProject(): Promise<PickscapeProject | null> {
  const row = await database.projects.get("active");
  if (!row?.project) return null;
  return {
    ...row.project,
    history: row.project.history.map((record) => ({
      ...record,
      keptInPool: record.keptInPool ?? false,
    })),
    settings: {
      ...DEFAULT_SETTINGS,
      ...row.project.settings,
      selectedCategories: row.project.settings.selectedCategories ?? [],
    },
  };
}

export async function clearRememberedProject(): Promise<void> {
  await database.projects.delete("active");
}
